import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import './SidebarComponent.css';
import { UseSidebar } from '../../hook/SidebarHook';
import { PrivateRoutes } from '../../../main/constant/RouteConstant';
import logo from '../../images/Logo intelidente Lite Branca.png';
import { IoHome } from 'react-icons/io5';
import { GoSidebarExpand } from 'react-icons/go';
import { FaRegCalendarAlt, FaLock, FaRegIdCard, FaSlidersH, FaUserMd } from 'react-icons/fa';
import { UseAuth } from '../../hook/AuthHook';
import { ProfilesConstant } from '../../../main/constant/ProfilesConstant';

const SidebarComponent: React.FC = () => {
  const PROFILE_ADMIN = ProfilesConstant.admin;
  const PROFILE_RECEPCIONISTA = ProfilesConstant.receptionist;

  const [isOpen, setIsOpen] = useState(true);
  const { setOpen } = UseSidebar();
  const { loggedUserData } = UseAuth();
  const [permissao, setPermissao] = useState<string[] | null>(null);
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  useEffect(() => {
    if (loggedUserData?.roles) {
      setPermissao(loggedUserData.roles);
    } else {
      setPermissao(null);
    }
  }, [loggedUserData]);

  useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth <= 768;
      setIsMobile(isMobileView);

      if (isMobileView) {
        setIsOpen(false);
        setOpen(false);
      } else {
        setIsOpen(true); // Para garantir que a sidebar esteja aberta em telas grandes.
        setOpen(true);
      }
    };

    // Define o estado inicial com base no tamanho da tela
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setOpen]);

  const hasRole = (role: string) => permissao?.includes(role);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    setOpen(!isOpen);
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      {!isMobile && (
        <div className="sidebar-header">
          {isOpen && (
            <>
              <div className="menu-img" onClick={toggleSidebar}>
                <Image src={logo} width={120} style={{ color: '#f4f3f3' }} />
              </div>
              <div className="menu-btn" onClick={toggleSidebar}>
                <GoSidebarExpand />
              </div>
            </>
          )}
          {!isOpen && (
            <div className="menu-btn" onClick={toggleSidebar}>
              <GoSidebarExpand />
            </div>
          )}
        </div>
      )}

      <div className="sidebar-content">
        <a href={PrivateRoutes.HOME} className="sidebar-link">
          <IoHome className="icon-lg" />
          {isOpen && <span>Home</span>}
        </a>

        <a href={PrivateRoutes.LIST_APPOINTMENT} className="sidebar-link">
          <FaRegCalendarAlt className="icon-lg" />
          {isOpen && <span>Agendamento</span>}
        </a>

        {(hasRole(PROFILE_ADMIN) || hasRole(PROFILE_RECEPCIONISTA)) && (
          <a href={PrivateRoutes.LIST_PATIENT} className="sidebar-link">
            <FaRegIdCard className="icon-lg" />
            {isOpen && <span>Pacientes</span>}
          </a>
        )}

        {(hasRole(PROFILE_ADMIN) || hasRole(PROFILE_RECEPCIONISTA)) && (
          <a href={PrivateRoutes.LIST_PROFESSIONAL} className="sidebar-link">
            <FaUserMd className="icon-lg" />
            {isOpen && <span>Profissionais</span>}
          </a>
        )}
      </div>

      <hr className="divider" />

      <div className="sidebar-bottom">
        {hasRole(PROFILE_ADMIN) && (
          <a href={PrivateRoutes.EDIT_CLINIC} className="sidebar-link">
            <FaSlidersH className="icon-lg" />
            {isOpen && <span>Clínica</span>}
          </a>
        )}

        <a href={PrivateRoutes.CHANGE_PASSWORD} className="sidebar-link">
          <FaLock className="icon-lg" />
          {isOpen && <span>Trocar senha</span>}
        </a>
      </div>
    </div>
  );
};

export default SidebarComponent;
